import React from "react";
import classes from "./IconLightTheme.module.scss";
function IconLightTheme() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      className={classes.iconLightTheme}
    >
      <path
        fill="#828FA3"
        d="M9.167 15.833a.833.833 0 01.833.834v.833a.833.833 0 01-1.667 0v-.833a.833.833 0 01.834-.834zM3.75 13.75a.833.833 0 01.59 1.422l-1.25 1.25a.833.833 0 01-1.18-1.178l1.25-1.25a.833.833 0 01.59-.244zm10.833 0c.221 0 .433.088.59.244l1.25 1.25a.833.833 0 01-1.179 1.178l-1.25-1.25a.833.833 0 01.59-1.422zM9.167 5a4.167 4.167 0 110 8.334 4.167 4.167 0 010-8.334zm-7.5 3.333a.833.833 0 010 1.667H.833a.833.833 0 110-1.667h.834zm15.833 0a.833.833 0 010 1.667h-.833a.833.833 0 010-1.667h.833zm-1.667-6.666a.833.833 0 01.59 1.422l-1.25 1.25a.833.833 0 11-1.179-1.178l1.25-1.25a.833.833 0 01.59-.244zm-13.333 0c.221 0 .433.088.59.244l1.25 1.25a.833.833 0 01-1.18 1.178L1.91 3.09a.833.833 0 01.59-1.422zM9.167 0A.833.833 0 0110 .833v.834a.833.833 0 11-1.667 0V.833A.833.833 0 019.167 0z"
      ></path>
    </svg>
  );
}

export default IconLightTheme;
